import { Link } from "react-router-dom";

const FAQ = [
  {
    q: "How do returns work?",
    a: "Open My Orders, find a delivered order and choose Request Return. Once the vendor confirms receipt of the returned item, your refund is processed.",
  },
  {
    q: "How are refunds issued?",
    a: "You choose at return time: back to your original payment method (5–7 working days via Razorpay), or as store credit that applies instantly to future orders.",
  },
  {
    q: "What are the shipping timelines?",
    a: "Approved vendors dispatch directly to you. Free shipping applies on orders over ₹2000; a flat ₹99 applies below that.",
  },
  {
    q: "Why do I verify my mobile at checkout?",
    a: "A verified number keeps your order and delivery updates tied to you and helps prevent fraud. You'll receive a one-time code by SMS.",
  },
  {
    q: "What does 'Spotter Certified' mean?",
    a: "Every product is physically inspected against a reference sample before it's listed — authenticity, quality, and fit. Read the full method on the Process page.",
  },
];

export default function HelpSupport() {
  return (
    <div className="max-w-[900px] mx-auto px-6 md:px-12 py-12">
      <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">We're here</p>
      <h1 className="font-serif text-6xl tracking-tighter">Help &amp; Support.</h1>

      <div className="mt-12 divide-y divide-foreground/15 border-y border-foreground">
        {FAQ.map((f) => (
          <div key={f.q} className="py-6">
            <h3 className="font-serif text-2xl tracking-tight">{f.q}</h3>
            <p className="mt-2 text-muted-foreground leading-relaxed max-w-2xl">{f.a}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 border border-foreground p-8 tag-punch pl-14 max-w-xl">
        <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Still need help?</p>
        <p className="font-serif text-3xl tracking-tight mt-2">Talk to a Spotter.</p>
        <div className="mt-4 space-y-1 font-mono text-sm">
          <p>Email · <a href="mailto:support@thespotters.in" className="underline hover:text-[hsl(var(--accent))]">support@thespotters.in</a></p>
          <p className="text-muted-foreground">Mon–Sat · 10:00–18:00 IST</p>
        </div>
      </div>

      <p className="mt-8 font-mono text-[11px] text-muted-foreground">
        Looking for an order? <Link to="/account" className="underline hover:text-foreground">My Orders</Link>
      </p>
    </div>
  );
}
